import React from "react";
import { Tabs, Button } from "antd";
import Main from "../../components/layout/Main";
import TumanentImage from "../../assets/images/tunamnet-tubhnail-image.jpg";
import GamesImage from "../../assets/images/games-image.jpg";
import TrofiesImage from "../../assets/images/trofies-image.svg";
import { useNavigate } from "react-router";


const { TabPane } = Tabs;

const tournaments = [
  {
    date: "27 March 2025 | 9:30 PM",
    slots: "5/5 slots",
    timeLeft: "14h 30min",
    status: "Active",
    trophies: ["Gold", "Silver", "Bronze"],
    game: "Assassin Creed – PVP",
    image: TumanentImage,
  },
  {
    date: "27 March 2025 | 9:30 PM",
    slots: "5/5 slots",
    timeLeft: "14h 30min",
    status: "Active",
    trophies: ["Gold", "Silver", "Bronze"],
    game: "Assassin Creed – PVP",
    image: TumanentImage,
  },
  {
    date: "27 March 2025 | 9:30 PM",
    slots: "5/5 slots",
    timeLeft: "14h 30min",
    status: "Active",
    trophies: ["Gold", "Silver", "Bronze"],
    game: "Assassin Creed – PVP",
    image: TumanentImage,
  },
];
const Games = [
  {
    image: GamesImage,
  },
  {
    image: GamesImage,
  },
  {
    image: GamesImage,
  },
  {
    image: GamesImage,
  },
];

const HomePage = () => {

  const Navigate = useNavigate();


  return (
    <Main>
      <div className="home-container">
        <Tabs defaultActiveKey="1" className="custom-tabs">
          <TabPane tab="Current" key="1">
            <Section
              title="Tournaments"
              data={tournaments}
              type="tournament"
              navigate={Navigate}
            />
            <Section
              title="Games"
              data={Games}
              type="game"
              navigate={Navigate}
            />
          </TabPane>
          <TabPane tab="Upcoming" key="2">
            <Section
              title="Tournaments"
              data={tournaments}
              type="tournament"
              navigate={Navigate}
            />
            <Section
              title="Games"
              data={Games}
              type="game"
              navigate={Navigate}
            />
          </TabPane>
        </Tabs>
      </div>
    </Main>
  );
};


const Section = ({ title, data, type , navigate }) => (



  
  <div className="section-block">
    {type === "tournament" ? (
      <>
        <div className="section-header">
          <div className="orange-header">{title}</div>
      <span className="view-all">View All</span>
        </div>
        <div className="main-grid-class">
          {data.map((item, index) => (
            <div key={index} className="tournament-card">
              <div className="tunament-image">
                <img alt="thumbnail" src={item.image} />
              </div>

              <div className="card-top-info">
                <div className="tunament-date">{item.date}</div>
                <div className="starts-time">
                  Starts in: <span>{item.timeLeft}</span>
                </div>
              </div>

              <div className="card-tags">
                <img src={TrofiesImage} alt="Trophies" />
                <span>
                  {item.trophies.map((t, i) => (
                    <span key={i}>
                      {t}
                      {i < item.trophies.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </span>
              </div>

              <div className="tunament-slot">{item.slots}</div>

              <div className="tunamnet-game-name-main">
                <div className="tunamnet-game-name">
                  <h5>
                    {item.game} <span>{item.status}</span>
                  </h5>
                </div>
                <Button className="join-button Fill-button">Join</Button>
              </div>
            </div>
          ))}
        </div>
      </>
    ) : type === "game" ? (
      <>
        <div className="section-header">
          <div className="orange-header">{title}</div>
            <span className="view-all" onClick={() => navigate("/all-games")}>View All</span>
        </div>
        <div className="main-grid-new">
          {data.map((item, index) => (
            <div key={index} className="game-card">
              <img src={item.image} alt="Game" className="game-image" />
            </div>
          ))}
        </div>
      </>
    ) : null}
  </div>
);


export default HomePage;
